import { StreamingText } from '@/_shared/components/StreamingText';
import { Callout } from '@/_shared/components/ui/callout';

type AlertSeverity = 'error' | 'warning' | 'info' | 'success';

interface AlertBlockProps {
  content: string;
  metadata?: unknown;
}

function isValidSeverity(value: string): value is AlertSeverity {
  return value === 'error' || value === 'warning' || value === 'info' || value === 'success';
}

function getVariant(metadata: unknown): AlertSeverity {
  if (metadata && typeof metadata === 'object' && 'severity' in metadata && typeof metadata.severity === 'string') {
    if (isValidSeverity(metadata.severity)) return metadata.severity;
  }
  return 'info';
}

export function AlertBlock({ content, metadata }: AlertBlockProps): React.ReactElement {
  const variant = getVariant(metadata);

  return (
    <Callout variant={variant} data-testid={`alert-${variant}`}>
      <StreamingText content={content} />
    </Callout>
  );
}
